import { createReducer, on } from '@ngrx/store';
import { FeatureFlagsState } from '../../models/states/feature-flags-state.interfaces';
import * as fromFeatureFlagsActions from '../actions/feature-flags.actions';

export const FeatureFlagsStateKey = 'featureFlags';

const initialState: FeatureFlagsState = {
  featureFlags: null
};

export const featureFlagsReducer = createReducer(
  initialState,
  on(
    fromFeatureFlagsActions.StoreFeatureFlagsValuesSuccess,
    (state, { featureFlags }) => ({
      ...state,
      featureFlags
    })
  )
);
